import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { LabelMedium } from '../../../../../../../primitives/index.js';
export const Link = /*#__PURE__*/_styled(LabelMedium, process.env.NODE_ENV === "production" ? {
  target: "e1lgilcf0"
} : {
  target: "e1lgilcf0",
  label: "Link"
})(process.env.NODE_ENV === "production" ? {
  name: "e0603k",
  styles: "display:flex;gap:8px;cursor:pointer"
} : {
  name: "e0603k",
  styles: "display:flex;gap:8px;cursor:pointer/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpbmsuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRXdDIiwiZmlsZSI6IkxpbmsuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBMYWJlbE1lZGl1bSB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IExpbmsgPSBzdHlsZWQoTGFiZWxNZWRpdW0pIGBcbiAgZGlzcGxheTogZmxleDtcbiAgZ2FwOiA4cHg7XG4gIGN1cnNvcjogcG9pbnRlcjtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1MaW5rLmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});